<template>
<v-container fluid>
  <v-card>
    <v-card-title>
      <div class="flex-grow-1">
      </div>   
      <div class="flex-grow-1">
        <v-row justify="end">
          <v-col 
            cols="3" 
            sm="3"
          >
            
          </v-col>
        </v-row>
      </div>
    </v-card-title>
    <v-card-text>
      <v-data-table
      dense
     
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        calculate-widths
        loading-text="Cargando... Por favor espere"
        locale="es-ES"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
@page-count="pageCount = $event"

        

      >
      </v-data-table>
      <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
      ></v-pagination>
      
      </div>
    </v-card-text>
  </v-card>
  
  <v-snackbar
    key="snackbarDataTableServicioResponsables"
    v-model="snackbar"
    :bottom="true"
    :multi-line="true"
    :color="snackbarColor"
  >
    {{ snackbarTexto }}
    <v-btn dark text @click="snackbar = false;">
      Cerrar
    </v-btn>
  </v-snackbar> 
</v-container>
</template>

<script>
import {getListadoRepuestasCapturaLibreByIdPregunta } from "@/api";

export default {
  name: "DataTableRespuestasEspecificas",
  components: {
    
    },
  
  props: {
      idEncuesta: {
      type: Number,
      required: true,
    },
    idPregunta: {
      type: Number,
      required: true,
    },  
    fecha: {
      type: String,
      required: true,
    }, 
     fecha2: {
      type: String,
      required: true,
    }, 
    mostrarTodos:{
      type: Boolean,
      required:true
    },
    idCampus: {
      type: String,
      required: true,
    }, 
     idDivision: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      page: 1,
        pageCount: 0,
        itemsPerPage: 10,
      loading: true,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',
      headers: [
      
        { class: 'primary--text', align: "center", text: "Respuestas", value: "textoRespuesta" },
        {  class: 'primary--text',align: "left", text: "Cantidad", value: "cantidad" }
    
      ],
      items: [],
      itemsFilter: [],
      search: "",
      dialog: false,
      itemSelected: {},
      itemDelete: {},
      dialogEliminar:  false,
      loadingEliminar: false,
    };
  },
  computed: {},
  watch: {
    flagReload: {
      handler (newValue, oldValue) {
        this.obtenerRoles();
			},
    },
  },
  mounted () {
    this.obtenerRoles();
  },
  methods: {
    async obtenerRoles () {
      var self = this;
      self.loading = true;
      self.items = [];
      self.itemsFilter = [];
      self.snackbarError = false;
      self.textoError = "";
let response ="";
      try {
        if(self.mostrarTodos==true){
           if(self.idCampus==null){
             response = await getListadoRepuestasCapturaLibreByIdPregunta(this.idEncuesta, this.idPregunta, '', '', '', '');
           }
           else{
        if(self.idCampus!=null&&self.idDivision==null){
          response = await getListadoRepuestasCapturaLibreByIdPregunta(this.idEncuesta, this.idPregunta, '', '', this.idCampus, '');
        }
        else{
        if(self.idCampus!=null&&self.idDivision!=null){
          response = await getListadoRepuestasCapturaLibreByIdPregunta(this.idEncuesta, this.idPregunta, '', '', this.idCampus, this.idDivision);
        }
        }
        }
        }
        else{
           if(self.idCampus==null){
            response = await getListadoRepuestasCapturaLibreByIdPregunta(this.idEncuesta, this.idPregunta, this.fecha, this.fecha2, '', '');
           }
             else{
        if(self.idCampus!=null&&self.idDivision==null){
         response = await getListadoRepuestasCapturaLibreByIdPregunta(this.idEncuesta, this.idPregunta, this.fecha, this.fecha2, this.idCampus, '');
        }
        else{
        if(self.idCampus!=null&&self.idDivision!=null){
         response = await getListadoRepuestasCapturaLibreByIdPregunta(this.idEncuesta, this.idPregunta, this.fecha, this.fecha2, this.idCampus, this.idDivision);
        }
        }
        }
      
          }
          if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.items = response.data.data;
              self.loading = false;
            }
          } else {
            self.snackbarTexto = "DataTableEncuestaRoles: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableEncuestaRoles: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableEncuestaRoles: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },

  }
};
</script>